<wuc-display-table>
    <ng-container *ngFor="let coverage of coverages; let last = last">
        <wuc-display-table-row [hasBoldBorder]="last">
            <wuc-display-table-label>{{ coverage.coverageDescription }}</wuc-display-table-label>
            <wuc-display-table-value *ngIf="coverage.premium">
                <span class="no-brake">
                    {{ coverage.premium.premiumIncludingPremiumTax ? (coverage.premium.premiumIncludingPremiumTax | number : "1.2-2") : 'gratis' }}
                </span>
            </wuc-display-table-value>
        </wuc-display-table-row>
        <wuc-display-table-row *ngIf="coverage.collectivityDiscount">
            <wuc-display-table-label>{{ purchasedProduct.coverage.collectivityDescription }}</wuc-display-table-label>
            <wuc-display-table-value>
                <span class="no-brake">
                    -{{ coverage.collectivityDiscount.premiumIncludingPremiumTax | number : "1.2-2" }}
                </span>
            </wuc-display-table-value>
        </wuc-display-table-row>
    </ng-container>
    <wuc-display-table-row *ngIf="purchasedProduct.coverage?.totalDiscount">
        <wuc-display-table-label>Subtotaal</wuc-display-table-label>
        <wuc-display-table-value>
            <span class="no-brake">{{ coveragePremiumTotal.premium | number : "1.2-2" }}</span>
        </wuc-display-table-value>
    </wuc-display-table-row>
    <wuc-display-table-row *ngIf="
                purchasedProduct.coverage.offer &&
                purchasedProduct.coverage.totalDiscount?.premiumIncludingPremiumTax > 0

            ">
        <wuc-display-table-label>{{ purchasedProduct.coverage.offer }}</wuc-display-table-label>
        <wuc-display-table-value>
            <span class="no-brake">
                {{ -purchasedProduct.coverage.totalDiscount.premiumIncludingPremiumTax | number : "1.2-2" }}
            </span>
        </wuc-display-table-value>
    </wuc-display-table-row>
    <wuc-display-table-row *ngIf="
                !purchasedProduct.coverage.offer &&
                purchasedProduct.coverage.totalDiscount?.premiumIncludingPremiumTax > 0
            ">
        <wuc-display-table-label>Korting</wuc-display-table-label>
        <wuc-display-table-value>
            <span class="no-brake">{{ -purchasedProduct.coverage.totalDiscount.premiumIncludingPremiumTax | number : "1.2-2" }}</span>
        </wuc-display-table-value>
    </wuc-display-table-row>
    <wuc-display-table-row [hasBoldBorder]="true">
        <wuc-display-table-label [isBold]="true">Mijn maandbedrag</wuc-display-table-label>
        <wuc-display-table-value>
            <wuc-price [price]="coveragePremiumTotal.premiumIncludingDiscount"></wuc-price>
        </wuc-display-table-value>
    </wuc-display-table-row>
</wuc-display-table>
